export default __webpack_public_path__ + "assets/146de86eb915c83357ac6c24b4055da9.png";